define.alias("shared/components/shared/upgrade/feature", "settings/components/shared/upgrade/feature");